import { useLocale } from '../contexts/LocaleContext';
import { HardwareFirstTrialTerms } from '../components/HardwareFirstTrialToggle/HardwareFirstTrialModal';
import { formatHardwarePrice } from '../lib/hardwareFirst';
import useFreeTrialShippingPriceInCents from './useFreeTrialShippingPriceInCents';
import useHardwareFirstMembershipTerms from './useHardwareFirstMembershipTerms';

/**
 * The prices the hardware-first trial terms quote: the tracker's list price, the 12-month membership's
 * first year, and trial shipping in whole dollars when it is even. Undefined until the list price and the
 * membership terms have loaded.
 */
export default function useHardwareFirstTrialTerms(
  listPriceInCents: number | undefined,
): HardwareFirstTrialTerms | undefined {
  const locale = useLocale();
  const shippingInCents = useFreeTrialShippingPriceInCents();
  const yearTerm = useHardwareFirstMembershipTerms().find((term) => term.renewalMonths === 12);

  return yearTerm && listPriceInCents !== undefined
    ? {
        listPrice: formatHardwarePrice(listPriceInCents, locale),
        firstYear: yearTerm.intro,
        shippingPrice: shippingInCents > 0 ? formatHardwarePrice(shippingInCents, locale) : null,
      }
    : undefined;
}
